import { jsx as c, jsxs as dt } from "react/jsx-runtime";
import { forwardRef as ut, useState as d, useRef as u, useEffect as f, useMemo as mt, useCallback as p, useImperativeHandle as ft } from "react";
import { createPortal as pt } from "react-dom";
import a from "./styles.module.less.js";
import wt from "./close-icon.svg.js";
import { useDisableScroll as gt } from "../../../utils/use-disable-scroll.js";
import { PREMATTER_ID_COOKIE as It, ATTICUS_JOB_ID_KEY as _t, ATTICUS_EMAIL_KEY as Tt, ATTICUS_PREMATTER_ID_KEY as G } from "../../../utils/atticus-storage-keys.js";
import { AiChatPromptModal as ht } from "../ai-chat-prompt-modal/index.js";
import { createAtticusModal as Ct } from "./create-atticus-modal.js";
const At = 200, St = ut(
  ({
    defaultOpen: et = !1,
    onClose: n,
    onOpen: w,
    iframeUrl: O,
    category: l = null,
    suburb: g = null,
    suburbId: Y = null,
    utmContent: k,
    fromFirm: y,
    additionalParams: i = {},
    ga4MeasurementId: I,
    onIframeLoad: N,
    onCloseWithData: $,
    onShareBriefSuccess: _,
    source: q = "lawconnect",
    user: m,
    context: j,
    showAiChatPrompt: H = !1,
    chatRedirectUrl: J = "/chat"
  }, rt) => {
    const [T, D] = d(et), [C, h] = d(!1), [A, z] = d(!1), [S, st] = d(""), [L, it] = d(""), [ot, E] = d(!1), P = u(null), r = u(null), Q = u(""), M = u(!1), U = u(null), K = u(!1);
    gt({ isDisabled: T }), f(() => {
      (() => {
        if (typeof window < "u" && window.gtag)
          try {
            if (I) {
              window.gtag(
                "get",
                I,
                "client_id",
                (t) => {
                  t && st(t);
                }
              ), window.gtag(
                "get",
                I,
                "session_id",
                (t) => {
                  t && it(t);
                }
              );
              return;
            }
          } catch (t) {
            console.warn("Failed to get GA4 data from gtag:", t);
          }
      })();
    }, [I]);
    const R = mt(() => {
      const e = new URLSearchParams();
      Object.entries(i).forEach(([s, v]) => {
        s !== "client_id" && s !== "session_id" && e.append(s, v);
      }), S && e.append("client_id", S), L && e.append("session_id", L);
      const t = e.toString();
      return `${O}${t ? `?${t}` : ""}`;
    }, [O, i, S, L]);
    f(() => {
      R !== Q.current && z(!1), Q.current = R;
    }, [R]);
    const nt = p(() => {
      r.current && (clearTimeout(r.current), r.current = null), M.current = !1, U.current = null, h(!1), E(!1), D(!0), w == null || w();
    }, [w]), x = p(() => {
      K.current || (r.current && clearTimeout(r.current), h(!0), r.current = setTimeout(() => {
        D(!1), h(!1), E(!1), n == null || n();
      }, At));
    }, [n]), b = p(() => {
      H && !M.current ? E(!0) : x();
    }, [H, x]), at = p(
      (e) => {
        const t = new URLSearchParams({ newCase: "true", message: e }), s = U.current || g;
        l && t.set("category", l), s && t.set("location", s), window.location.href = `${J}?${t.toString()}`;
      },
      [J, l, g]
    ), ct = p(() => {
      r.current && (clearTimeout(r.current), r.current = null), E(!1), D(!1), h(!1), K.current = !0, n == null || n(), K.current = !1;
    }, [n]);
    f(() => () => {
      r.current && clearTimeout(r.current);
    }, []);
    const lt = () => {
      z(!0), N == null || N();
    };
    return f(() => {
      T && A && setTimeout(() => {
        var e;
        if (P.current) {
          const t = {
            type: "init-atticus",
            payload: {
              category: l || null,
              suburb: g || null,
              suburbId: Y || null,
              ...y ? { fromFirm: y } : {},
              utm: {
                utmSource: i.utm_source || void 0,
                utmContent: k || void 0,
                utmCampaign: i.utm_campaign || void 0,
                utmMedium: i.utm_medium || void 0,
                utmTerm: i.utm_term || l || void 0,
                gclid: i.gclid || void 0,
                gaClientId: S || void 0
              },
              source: q,
              sourceUrl: window.location.href,
              // Include all stored query string parameters
              queryParams: i,
              // Include context if provided
              ...j ? { context: j } : {},
              // Include user if provided
              ...m ? {
                user: {
                  name: m.name,
                  email: m.email,
                  phone: m.phone
                }
              } : {}
            }
          };
          try {
            (e = P.current.contentWindow) == null || e.postMessage(t, "*");
          } catch (s) {
            console.error("❌ Error sending postMessage:", s);
          }
        }
      }, 100);
    }, [
      T,
      A,
      l,
      g,
      Y,
      k,
      y,
      i,
      q,
      j,
      m
    ]), f(() => {
      const e = async (t) => {
        var s, v, X, Z, F, W, V, B;
        if (((s = t.data) == null ? void 0 : s.type) === "close-atticus") {
          const o = {
            email: (v = t.data) == null ? void 0 : v.email,
            jobId: (X = t.data) == null ? void 0 : X.jobId
          };
          window.sessionStorage.removeItem(It), o.jobId && window.sessionStorage.setItem(_t, o.jobId), o.email && window.sessionStorage.setItem(Tt, o.email);
          const tt = window.sessionStorage.getItem(
            G
          );
          $ ? await $(o) : tt && (window.sessionStorage.removeItem(G), window.location.href = `/case/${tt}`), M.current = !0, b();
        } else if (((Z = t.data) == null ? void 0 : Z.type) === "share-brief-success") {
          M.current = !0;
          const o = {
            prematterId: (F = t.data) == null ? void 0 : F.prematterId,
            jobId: (W = t.data) == null ? void 0 : W.jobId
          };
          o.prematterId && window.sessionStorage.setItem(
            G,
            o.prematterId
          ), _ == null || _(o);
        } else ((V = t.data) == null ? void 0 : V.type) === "atticus-context-update" && (B = t.data) != null && B.locationId && (U.current = t.data.locationId);
      };
      return window.addEventListener("message", e), () => {
        window.removeEventListener("message", e);
      };
    }, [b, $, _]), ft(rt, () => ({
      openModal: nt,
      closeModal: x
    })), !T && !C ? null : ot ? /* @__PURE__ */ c(
      ht,
      {
        onSubmit: at,
        onClose: ct
      }
    ) : pt(
      /* @__PURE__ */ c(
        "div",
        {
          className: `${a.modal} ${C ? a.closing : ""}`,
          onClick: b,
          children: /* @__PURE__ */ dt(
            "div",
            {
              className: `${a.modalContent} ${C ? a.closing : ""}`,
              onClick: (e) => e.stopPropagation(),
              children: [
                /* @__PURE__ */ c("div", { className: a.close, onClick: b, children: /* @__PURE__ */ c(wt, {}) }),
                !A && /* @__PURE__ */ c("div", { className: a.loadingSpinner, children: /* @__PURE__ */ c("div", { className: a.spinner }) }),
                /* @__PURE__ */ c(
                  "iframe",
                  {
                    ref: P,
                    src: R,
                    width: "100%",
                    height: "100%",
                    onLoad: lt,
                    className: a.iframe,
                    title: "Atticus AI Assistant",
                    style: { opacity: A ? 1 : 0 }
                  }
                )
              ]
            }
          )
        }
      ),
      document.body
    );
  }
);
St.displayName = "AtticusModal";
export {
  St as AtticusModal,
  Ct as createAtticusModal
};
